import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { IDxIcdCodes } from 'src/app/models/IDXDetails';
import { configuration } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ManageICDService {

  constructor(private http: HttpClient) { }
  getDxAllIcdWithCategory(): Observable<IDxIcdCodes[]> {
    return this.http.get<IDxIcdCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/DxAllIcdWithCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  saveICDCodes(IcdCodes: IDxIcdCodes): Observable<IDxIcdCodes> {
    const posteddata={
      inputdata:JSON.stringify(IcdCodes)
    } 
    return this.http.post<IDxIcdCodes>(`${configuration.clinicapiUrl + 'Encounter/insertUpdateICDCodes'}`, posteddata, 
    {
    });
  }

  SaveICDcategory(categoryname: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/InsertICDcategory'}?categoryname=${categoryname}`, categoryname,{
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getICDBySearch(ICDCode:string): Observable<any[]> {
    return this.http.get<any[]>
      (`${configuration.apiUrl + 'Master/SearchICDCodes'}?ICDCode=${ICDCode}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  //
}
